import { render, staticRenderFns } from "./PedidosValidar.vue?vue&type=template&id=573455d6&scoped=true&lang=pug"
import script from "./PedidosValidar.vue?vue&type=script&lang=js"
export * from "./PedidosValidar.vue?vue&type=script&lang=js"
import style0 from "./PedidosValidar.vue?vue&type=style&index=0&id=573455d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573455d6",
  null
  
)

export default component.exports